import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Field, Form, reduxForm } from 'redux-form';
import { Button, ButtonBar, FormGroupRow } from '../../../../common/components';
import { Modal } from 'react-bootstrap';
import { compose } from 'redux';
import { actions } from '../../redux/policyActions';
import AsyncSelectMenu from '../../../../common/components/SelectMenu/AsyncSelectMenu';
import { required } from 'redux-form-validators';

const UpdateSourceButton = ({
  policyId,
  policyNumber,
  updateSource,
  getPolicy,
  reset,
  handleSubmit,
  submitting,
}) => {
  const [show, setShow] = useState(false);

  const handleChangeSource = (values) => {
    return Promise.resolve(updateSource(policyId, values))
      .then(() => {
        getPolicy(policyId);
      })
      .finally(() => {
        setShow(false);
      });
  };

  const openModal = () => {
    reset();
    setShow(true);
  };

  const closeModal = () => {
    setShow(false);
  };

  return (
    <>
      <Button bsStyle="primary" className="pull-right pad-right" handleClick={openModal}>
        Update Source
      </Button>
      <Modal show={show} onHide={closeModal}>
        <Form onSubmit={handleSubmit(handleChangeSource)}>
          <Modal.Header closeButton>
            <Modal.Title>Update Source for {policyNumber}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h3>Please select a source..</h3>

            <FormGroupRow label={'Source'} labelSize={2}>
              <Field
                name="data.relationships.source.data.id"
                url={'/sources'}
                optionValuePath={'id'}
                component={AsyncSelectMenu}
                validate={required({ msg: 'source is required' })}
              />
            </FormGroupRow>
          </Modal.Body>
          <Modal.Footer>
            <ButtonBar>
              <Button
                className="pull-right"
                type="submit"
                bsStyle="primary"
                isLoading={submitting}
                disabled={submitting}
              >
                Update
              </Button>
            </ButtonBar>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

const getInitialValues = () => () => ({
  data: {
    relationships: {
      source: {
        data: {
          id: '',
        },
      },
    },
  },
});

const FORM_NAME = 'ChangeSourceForm';
export default compose(
  connect(
    (state) => ({
      initialValues: getInitialValues()(state),
    }),
    {
      updateSource: actions.updateSource,
      getPolicy: actions.getPolicy,
    },
  ),
  reduxForm({
    form: FORM_NAME,
  }),
)(UpdateSourceButton);
